import script from "./AddBucketModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBucketModal.vue?vue&type=script&setup=true&lang=js"

import "./AddBucketModal.vue?vue&type=style&index=0&id=5ff239b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff239b8"]])

export default __exports__